import ClickableLink from 'components/Common/Clickable/ClickableLink'
import { ONLY_IN_AUSTRALIA_CAMPAIGN_PATH } from 'home/constants/onlyInAustraliaHeroCampaign'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import { useCallback, type MouseEvent } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  /** When true, wraps the pill in a link to the Only in Australia campaign page (offer page only). */
  linkToCampaign: boolean
}

function OnlyInAustraliaCampaignLabel({ linkToCampaign }: Props) {
  const intl = useIntl()

  const onClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
  }, [])

  const label = intl.formatMessage({
    id: 'bMsr1Yjh_qYqdrLXymIr',
    defaultMessage: 'Only in Australia',
    description:
      'Promotion pill on offer tiles for the Only in Australia marketing campaign; shown when the offer has a matching campaign tag.',
  })

  if (!linkToCampaign) {
    return (
      <StructureLabel variant="only-in-australia" startIcon={<LineMapMarkerIcon />}>
        {label}
      </StructureLabel>
    )
  }

  return (
    <ClickableLink to={ONLY_IN_AUSTRALIA_CAMPAIGN_PATH} onClick={onClick}>
      <StructureLabel variant="only-in-australia" startIcon={<LineMapMarkerIcon />}>
        {label}
      </StructureLabel>
    </ClickableLink>
  )
}

export default OnlyInAustraliaCampaignLabel
